import React, { useEffect } from "react";
import FormComponent from "./Form";
import "../index.css";


function Banner({ customADL, setCustomADL }) {
  return (
    <article
      className="banner_section position-relative">
      <picture className="img-box">
        <source
          rel="preload"
          media="(max-width:480.5px)"
          srcSet="dist/img/banner-mob.webp"
          alt="ICICI Bank saving account banner"
          width={428}
          height={320}
          className="img-fluid"
        />

        <source
          rel="preload"
          media="(max-width:767.5px)"
          srcSet="dist/img/banner-ipad.webp"
          alt="ICICI Bank saving account banner"
          width={428}
          height={320}
          className="img-fluid"
        />

        <img
          rel="preload"
          src="dist/img/banner-desk.webp"
          alt="Banner img"
          width={2560}
          height={893}
          className="img-fluid"
        />
      </picture>


      <div className="container banner_container1">
        <div className="row">
          <div className="col-md-7">
            <div className="banner-text">
              <h1 className="banner_head">Unlock endless possibilities with <br /> an ICICI Bank Savings Account</h1>
              <div className="banner_img">
                <div className="box_three">
                  <h2>ICICI 3-in-1</h2>
                  <img src="dist/img/three_bg.webp" width={351} height={350} alt="img Three" className="three_img" />
                  <div className="img_list">
                    <div><img src="dist/img/icons/Savings.svg" width={34} height={34} alt="icon - Savings" /> <span>Savings</span> </div>
                    <div><img src="dist/img/icons/Demat.svg" width={34} height={34} alt="icon - Demat" /> <span>Demat</span> </div>
                    <div><img src="dist/img/icons/Trading.svg" width={34} height={34} alt="icon - Trading" /> <span>Trading</span> </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="col-md-5 pos-rel">
            <div className="banner-bottom-heading d-block d-md-none">
              Get extra privileges with  our exclusive programmes.
            </div>
            <FormComponent customADL={customADL} setCustomADL={setCustomADL} />
          </div>
        </div>
      </div>
      <div className="banner-bottom-heading d-none d-md-block">
        Get extra privileges with
        <br className="d-md-none d-block" />
        our exclusive programmes. <span> </span>
      </div>
    </article >
  );
}
export default Banner;
